import { useNavigate, useParams } from 'react-router';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';
import ModalDialog from 'components/ModalDialog';
import { tenantConfig } from 'utils/tenant';
import { userSession } from 'state/session';
import { formatDateDisplay, formatTimeDisplay } from 'utils/date';

export default function PrescheduledRoute() {
  const navigate = useNavigate();
  const { brand, market } = useParams<{ brand: string; market: string }>();
  const { _ } = useLingui();
  const session = userSession().useState();

  const scheduledStartTime = session.scheduledStartTime;
  const startWindowBefore = tenantConfig().config?.scheduler?.startWindowBeforeMinutes ?? 5;

  // Calculate the date/time display
  const scheduledDate = scheduledStartTime ? new Date(scheduledStartTime) : new Date();
  const formattedDate = formatDateDisplay(scheduledDate, _);
  const formattedTime = formatTimeDisplay(scheduledDate);

  const handleAcknowledge = () => {
    if (brand && market) {
      userSession().reset();
      navigate(`/${brand}/${market}/`);
    }
  };

  return (
    <ModalDialog
      title={_(msg`Session Scheduled`)}
      message={_(
        msg`This session is scheduled for ${formattedDate} at ${formattedTime}. You can start it ${startWindowBefore} minutes before the scheduled time.`
      )}
      icon="ex3d-icon--calendar"
      linkText={_(msg`OK`)}
      onClick={handleAcknowledge}
      data-testid="prescheduled-modal"
    />
  );
}
